<template>
  <!--  -->
  <div class="custom">
    <heads></heads>
    <div class="container">
      <div
        class="container-top"
        v-if="bannerArray"
        :style="{ '--background': 'url(' +'\''+ bannerArray.path +'\''+ ')' }"
      ></div>
      <div class="container-bottom">
        <div class="custom-item">
          <div class="title title2"><span class="norequire">团建时长:</span></div>
          <div class="content">
            <div >
              <el-radio-group v-model="form.activityDay" >
                  <el-radio :label="item" border v-for="(item, index) in timeList"
              :key="index"></el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="custom-item">
          <div class="title title2"><span class="norequire">团建人数:</span></div>
          <div class="content">
            <el-radio-group v-model="form.peopleNumber">
                  <el-radio :label="item" border v-for="(item, index) in peopleNumberList"
              :key="index"></el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="custom-item component-select destinationContent">
          <div class="title title2"><span class="norequire">目的地:</span></div>
          <div class="content destinations">
            <el-input v-model="cityName" placeholder="搜索或选择想去的目的地" @input="showDestinationContent" @focus="showDestinationContent"></el-input>
            <p class="tip"><span class="el-icon-warning"></span>最多选择5个目的地</p>
            <div
                id="component-select-content"
                class="component-select-content "
                style="width: 760px"
                v-if="isSelectContent"
              >
                <div>
                  <div class="component-tabtitle">
                    <div
                      class="component-tabtitle-item"
                      v-for="(item, index) in selectTitle"
                      :key="item.id"
                      v-on:click.stop="selectTitleMethod(index)"
                      @mouseenter="selectTitleMethod(index)"
                    >
                      <span
                        class="component-tabtitle-name"
                        style="font-size: 16px; color: #222"
                        >{{ item.name }}</span
                      >
                      <div
                        class="component-tabtitle-border"
                        v-if="selectTitleNum == index"
                      ></div>
                    </div>
                  </div>
                  <div
                    class="
                      component-select-content-items
                      component-select-content-items-fold
                    "
                  >
                    <ul>
                      <li
                        v-for="item in destinationSecondList"
                        :key="item.id"
                        class=""
                        @click="selectContentMethod(item)"
                        :class="isSelectCity(item)?'active':''"
                      >
                        {{ item.name }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div> 
              <div class="destinationSearch" v-if="isShowDestinationSearch">
                <ul class="searchList">
                      <li class="searchItem"
                        v-for="item in destinationSearchList"
                        :key="item.id"
                        @click="isSelectCity(item)?()=>{return false}:selectContentMethod(item)"
                        :class="isSelectCity(item)?'select':'unselect'"
                      >
                       <span>{{ item.name }}<span v-if="isSelectCity(item)" class="selectTip">(已选择)</span> </span> 
                      </li>
                    </ul>
              </div> 
          </div>
        </div>
        <div class="custom-item  selectDestinations" v-if="destinations.length>0">
                <div class="selectDestinationItem" v-for="(item,index) in destinations" :key="index">
                    <span class="destinationName">{{ item.name }}</span>
                    <span class="close el-icon-close" @click="selectContentMethod(item)"></span>
                </div>
        </div>
        <div class="custom-item component-select playContent">
          <div class="title title2"><span class="norequire">团建玩法:</span></div>
          <div class="content plays">
            <el-input v-model="playName" placeholder="搜索或选择想玩的玩法" @input="showPlayContent" @focus="showPlayContent"></el-input>
            <p class="tip"><span class="el-icon-warning"></span>最多选择5个玩法</p>
            <div
                id="component-select-content"
                class="component-select-content"
                style="width: 760px"
                v-if="isPlayContent"
              >
                <div>
                  <div class="component-tabtitle">
                    <div
                      class="component-tabtitle-item"
                      v-for="(item, index) in playList"
                      :key="item.playTypeId"
                      v-on:click.stop="selectPlayTitleMethod(index)"
                      @mouseenter="selectPlayTitleMethod(index)"
                    >
                      <span
                        class="component-tabtitle-name"
                        style="font-size: 16px; color: #222"
                        >{{ item.playTypeName }}</span
                      >
                      <div
                        class="component-tabtitle-border"
                        v-if="selectPlayFirstNum == index"
                      ></div>
                    </div>
                  </div>
                  <div
                    class="
                      component-select-content-items
                      component-select-content-items-fold
                    "
                  >
                    <ul>
                      <li
                        v-for="item in playSecondList"
                        :key="item.playId"
                        class=""
                        @click="selectPlaySecond(item)"
                        :class="isSelectPlay(item)?'active':''"
                      >
                        {{ item.playName }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div> 
              <div class="playSearch" v-if="isShowPlaySearch">
                <ul class="searchList">
                      <li class="searchItem"
                        v-for="item in playSearchList"
                        :key="item.playId"
                        @click="isSelectPlay(item)?()=>{return false}:selectPlaySecond(item)"
                        :class="isSelectPlay(item)?'select':'unselect'"
                      >
                       <span>{{ item.playName }}<span v-if="isSelectPlay(item)" class="selectTip">(已选择)</span> </span> 
                      </li>
                    </ul>
              </div> 
          </div>
        </div>
        <div class="custom-item  selectPlays" v-if="plays.length>0">
            <div class="selectPlayItem" v-for="(item,index) in plays" :key="index">
                <span class="playName">{{ item.playName }}</span>
                <span class="close el-icon-close" @click="selectPlaySecond(item)"></span>
            </div>
        </div>
        <div class="custom-item">
          <div class="title title2"><span class="norequire">用餐标准:</span></div>
          <div class="content">
            <el-radio-group v-model="form.mealStandard">
                  <el-radio :label="item" border v-for="(item, index) in mealStandardsList"
              :key="index"></el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="custom-item">
          <div class="title title2"><span class="norequire">酒店标准:</span></div>
          <div class="content">
            <el-radio-group v-model="form.hotelStandard">
                  <el-radio :label="item" border v-for="(item, index) in hotelStandardsList"
              :key="index"></el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="custom-item">
          <div class="title title2"><span class="norequire">公司简称:</span></div>
          <div class="content">
            <el-input
              v-model="form.company"
              placeholder="公司简称"
              style="display: inline"
            ></el-input>
          </div>
        </div>
        <div class="custom-item">
          <div class="title title2"><span class="require">联系人</span><span class="mark">:</span></div>
          <div class="content">
            <el-input
              v-model="form.contact"
              placeholder="联系人"
              style="display: inline"
            ></el-input>
          </div>
        </div>
        <div class="custom-item">
          <div class="title title2"><span class="require">手机号</span><span class="mark">:</span></div>
          <div class="content">
            <el-input
              v-model="form.mobile"
              placeholder="11位手机号码"
              style="display: inline"
            ></el-input>
          </div>
        </div>
        <div class="custom-item">
          <div class="title title2"><span class="require">验证码</span><span class="mark">:</span></div>
          <div class="content">
            <div class="sendCode">
              <el-input
                v-model="form.verificationCode"
                placeholder="4位验证码"
                style="display: inline"
              ></el-input>
              <span :class="isPhoneNumber(form.mobile) ? 'active-txt2' : ''"
                @click="sendSMS"
                >{{ smsCodeTime != 0 ? smsCodeTime : "短信验证" }}</span>
            </div>
          </div>
        </div>
        <!-- <div class="custom-item">
          <div class="title title2"><span>备注:</span></div>
          <div class="content">
            <el-input
              type="textarea"
              v-model="form.description"
              placeholder="您可以在此补充一些需要告诉我们的消息"
            ></el-input>
          </div>
        </div> -->
        <div class="custom-last-item">
          <div @click="submit">提交团建需求</div>
        </div>
      </div>
    </div>
    <homeFoots></homeFoots>
  </div>
</template>

<script>
import heads from "@/components/comment/heads.vue";
import banners from "@/components/comment/banners.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import quickContact from "@/components/comment/quickContact.vue";
import axios from "axios";
import { handlePicPlusPre,isPhoneNumber } from "@/util/util.js";
import qs from "qs";
import wxShare from "@/common/wx_share.js";
export default {
  name: "articalDetail",
  data() {
    return {
      content: "",
      loading: false,
      // 短信重发时间
      smsCodeTime:0,
      // 时长
      timeList: [
      "一天","二天一晚","三天二晚","四天以上"
      ],
      // 人数
      peopleNumberList: [
      "10-30","30-50","50-100","100-200","200以上"
      ],
      // 酒店类型
      hotelStandardsList: [
      "星级酒店","商务酒店","快捷酒店","帐篷露营","不需要"
      ],
      // 用餐标准
      mealStandardsList: [
      "500元/围","600元/围","800元/围","1000元/围","不需要"
      ],
      customType: "个人",
      isCompany:false,
      isOther:false,
      serviceTypeDescription:"",
      selectForm:{
        // 时长
        activityDay:[],
        // 人数
        peopleNumber:[],
        // 用餐标准
        mealStandard:[],
        // 酒店星级
        hotelStandard:[],
      },
      // 提交表单
      form: {
        contact: "",
        mobile: "",
        company: "",
        description: "",
        // 时长
        activityDay:"",
        // 人数
        peopleNumber:"",
        // 用餐标准
        mealStandard:"",
        // 酒店星级
        hotelStandard:"",
        // 目的地
        destinationName:"",
        // 玩法
        playName:"",
      },
      destinations:[],
      bannerArray: [
        { path: "ak.jpg" },
      ],
      quickContactMessage:{
        type:1
      },
      cityName:"",
      selectTitleNum: 0,
      // 第一层选择序号
      selectPlayFirstNum: 0,
      destinationSecondList: [],
      allCityList:[],
      selectTitle: [
        {
          id: 1,
          name: "省内城市",
          child: [],
        },
        {
          id: 2,
          name: "国内城市",
          child: [],
        },
        {
          id: 3, 
          name: "国际长线",
          child: [],
        },
      ],
      isSelectContent:false,
      isShowDestinationSearch:false,
      destinationSearchList:[],
      playSearchList:[],
      isPlayContent:false,
      isShowPlaySearch:false,
      foreignCityList:[],
      domesticCityList:[],
      surroundCityList:[],
      closeDestinationContentFunction:"",
      closeDestinationListFunction:"",
      closePlayContentFunction:"",
      closePlayListFunction:"",
      playList:[],
      playSecondList:[],
      allPlaySecondList:[],
      // 玩法搜索列表
      playSearchList:[],
      // 输入的玩法名称
      playName:"",
      // 选中的玩法  
      plays:[]
    };
  },
  components: {
    heads,
    banners,
    homeFoots,
    quickContact,
  },
  computed: {
    getLocationSiteCityId() {
      return this.$store.state.locationSiteCity?this.$store.state.locationSiteCity:5;
    },
  },
  methods: {
    handlePicPlusPre,
    isPhoneNumber,
    // 获取团建查询条件
    getTbCondition() {
      axios.get("/api/tb/tbCondition").then((res) => {
        if (res.data && res.data.code == 200) {
          this.playList = res.data.play;
          if (
            this.playList
          ) {
            for (let index = 0; index < this.playList.length; index++) {
              const playItem = this.playList[index];
              if (index == 0) {
                this.playSecondList = playItem.playList;
              }
              this.allPlaySecondList = [...this.allPlaySecondList, ...playItem.playList];              
            }
          }
        }
      });
    },
    // 目的地的下拉框
    showDestinationContent(){
      if(this.cityName.length>0){
        this.isSelectContent = false;
        this.destinationSearchList = [
          ...this.foreignCityList.filter(city=>city.name.indexOf(this.cityName)!=-1),
          ...this.domesticCityList.filter(city=>city.name.indexOf(this.cityName)!=-1),
          ...this.surroundCityList.filter(city=>city.name.indexOf(this.cityName)!=-1)
        ];
        console.log("this.destinationSearchList",this.destinationSearchList)
        this.isShowDestinationSearch=true;
      }else{
        this.isShowDestinationSearch=false;
        this.isSelectContent = true;
      }
    },
    // 玩法的下拉框
    showPlayContent(){
      if(this.playName.length>0){
        this.isPlayContent = false;
        this.playSearchList = this.allPlaySecondList.filter(play=>play.playName.indexOf(this.playName)!=-1);
        console.log("this.playSearchList",this.playSearchList)
        this.isShowPlaySearch=true;
      }else{
        this.isShowPlaySearch=false;
        this.isPlayContent = true;
      }
    },
    // 点非弹框位置关闭弹框
    closeSelectContent() {
        this.closeDestinationContentFunction = (e) => {
        const model = document.querySelector(".destinations");
        if (!model ||!model.contains(e.target)) {
          this.isSelectContent = false;
        }
      };
      window.addEventListener("click", this.closeDestinationContentFunction);
      this.closeDestinationListFunction = (e) => {
        const model = document.querySelector(".destinationSearch");
        const model2 = document.querySelector(".destinationContent");
        if (!model ||!model2 ||  (!model.contains(e.target) &&!model2.contains(e.target) )) {
          this.isShowDestinationSearch = false;
        }
      };
      window.addEventListener("click", this.closeDestinationListFunction);
      this.closePlayContentFunction = (e) => {
        const model = document.querySelector(".plays");
        if (!model ||!model.contains(e.target)) {
          this.isPlayContent = false;
        }
      };
      window.addEventListener("click", this.closePlayContentFunction);
      this.closePlayListFunction = (e) => {
        const model = document.querySelector(".playSearch");
        const model2 = document.querySelector(".playContent");
        if (!model ||!model2 ||  (!model.contains(e.target) &&!model2.contains(e.target) )) {
          this.isShowPlaySearch = false;
        }
      };
      window.addEventListener("click", this.closePlayListFunction);
      
    },
    // 获取广告
    getBanner() {
      const params = {
        positionId: 23,
        cityId:this.getLocationSiteCityId
      };
      axios
        .get(`/api/adm/list`, {
          params,
        })
        .then((res) => {
          // console.log(res)
          if(res.data &&res.data.code == 200){
            if (res.data.adList) {
              this.bannerArray = res.data.adList;
              if (this.bannerArray && this.bannerArray.length>0) {
                this.bannerArray.forEach((banner) => {
                  if (banner.path) {
                    banner.path = this.handlePicPlusPre(banner.path);
                  } else {
                    banner.path = "ak.jpg";
                  }
                  banner.path = banner.path[0];
                });
                console.log(this.bannerArray)
                this.bannerArray = this.bannerArray[0];
              }else{
                this.bannerArray.path = "ak.jpg";
              }
              console.log(this.bannerArray)
            }
          }
        });
    },
 // 查询省内城市
 getSurroundCityList() {
      let cityId = this.getLocationSiteCityId;
      let params = {
        siteCityId: cityId,
      };
      axios
        .get(`/api/city/surroundCityList`, {
          params,
        })
        .then((res) => {
          if (res.status == 200 && res.data.code == 200) {
            this.surroundCityList = res.data.surroundCityList;
            if (this.surroundCityList) {
              this.surroundCityList.forEach((surroundCity) => {
                surroundCity.id = surroundCity.cityId;
                surroundCity.name = surroundCity.cityName;
              });
            }
            console.log();
            this.selectTitle[0].child = this.surroundCityList;
            this.destinationSecondList = this.surroundCityList;
          }
        });
      console.log("this.selectTitle[1].child");
      console.log(this.selectTitle[0].child);
    },
    // 查询国内城市
    getDomesticCityList() {
      let cityId = this.getLocationSiteCityId;
      let params = {
        siteCityId: cityId,
      };
            axios
        .get(`/api/city/domesticCityList`, {
          params,
        })
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.domesticCityList = res.data.domesticCityList;
            if (this.domesticCityList) {
              this.domesticCityList.forEach((domesticCity) => {
                domesticCity.id = domesticCity.cityId;
                domesticCity.name = domesticCity.cityName;
              });
            }
            console.log();
            this.selectTitle[1].child = this.domesticCityList;
          }
        });
    },
     // 查询国际长线
    getForeignCityList() {
      let cityId = this.getLocationSiteCityId;
      let params = {
        siteCityId: cityId,
      };
      axios
        .get(`/api/city/foreignCityList`, {
          params,
        })
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.foreignCityList = res.data.foreignCityList;
            if (this.foreignCityList) {
              this.foreignCityList.forEach((foreignCity) => {
                foreignCity.id = foreignCity.cityId;
                foreignCity.name = foreignCity.cityName;
              });
            }
            console.log();
            this.selectTitle[2].child = this.foreignCityList;
          }
        });
    },
    // 搜索二级标签选中
    selectContentMethod(item) {
      if(this.isSelectCity(item)){
        this.destinations = this.destinations.filter(destination => destination.id != item.id)
      }else{
        if(this.destinations.length>=5){
          this.$message({
                  message: "最多只能选择5个目的地！",
                  type: "warning",
                  duration: 1500,
                  center: true,
          });
          return;
        }
        this.destinations.push(item);
      }
      // this.isSelectContent = false;
      // this.isShowDestinationSearch = false;
      this.cityName = "";
    },
    // 判断城市是否被选中
    isSelectCity(item){
      let isFind = false;
      for (let index = 0; index < this.destinations.length; index++) {
        const destination = this.destinations[index];
        if(destination.id == item.id){
          isFind = true;
        }
      }
      return isFind;
    },
    // 搜索玩法二级标签选中
    selectPlaySecond(item) {
      if(this.isSelectPlay(item)){
        this.plays = this.plays.filter(play => play.playId != item.playId)
      }else{
        if(this.plays.length>=5){
          this.$message({
                  message: "最多只能选择5个玩法！",
                  type: "warning",
                  duration: 1500,
                  center: true,
          });
          return;
        }
        this.plays.push(item);
      }
      // this.isShowPlaySearch = false;
      // this.isPlayContent = false;
      this.playName = "";
    },
    // 判断玩法是否被选中
    isSelectPlay(item){
      let isFind = false;
      for (let index = 0; index < this.plays.length; index++) {
        const play = this.plays[index];
        if(play.playId == item.playId){
          isFind = true;
        }
      }
      return isFind;
    },
    clearForm(){
      // 提交表单
      this.form = {
        contact: "",
        mobile: "",
        company: "",
        description: "",
        // 时长
        activityDay:"",
        // 人数
        peopleNumber:"",
        // 用餐标准
        mealStandard:"",
        // 酒店星级
        hotelStandard:"",
        // 目的地
        destinationName:"",
        // 玩法
        playName:"",
      },
      this.selectForm = {
        // 时长
        activityDay:[],
        // 人数
        peopleNumber:[],
        // 用餐标准
        mealStandard:[],
        // 酒店星级
        hotelStandard:[],
      }
      this.plays = [];
      this.destinations = [];
    },
    // 搜索一级标签选中
    selectTitleMethod(index) {
      this.selectTitleNum = index;
      this.destinationSecondList = this.selectTitle[index].child;
    },
    // 搜索一级标签选中
    selectPlayTitleMethod(index) {
      this.selectPlayFirstNum = index;
      this.playSecondList = this.playList[index].playList;

    },
     // 发送短信
    sendSMS() {
      if(this.smsCodeTime>0 || !isPhoneNumber(this.form.mobile)){
        return;
      }
      let params = { mobile: this.form.mobile };
      axios
        .get(`/api/verificationCode/sendCode`, {
          params,
        })
        .then((res) => {
          if (res.data) {
            if (res.data.code == 200) {
              // 成功则重置短信验证码时间
              this.smsCodeTime = 60;
              this.smsDown();
            } else {
              if (res.data.code == 500) {
                let msg = "";
                if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "短信发送失败";
                }
                this.$message({
                  message: msg,
                  type: "warning",
                  duration: 1500,
                  center: true,
                });
              }
            }
          }
        });
    },
    // 短信计时器
    smsDown() {
      setInterval(() => {
        if (this.smsCodeTime != 0) {
          this.smsCodeTime = this.smsCodeTime - 1;
        }
      }, 1000);
    },
    // 提交表单
    submit() {
      let { contact, mobile, verificationCode } = this.form;
      console.log(!mobile || mobile.length != 11);
      console.log(!verificationCode);
      if (!mobile || mobile.length != 11) {
        this.$message({
          message: "请正确填写手机号码",
          type: "warning",
          duration: 1500,
          center: true,
        });
        return;
      }
      if (!verificationCode) {
        this.$message({
          message: "请正确填写验证码",
          type: "warning",
          duration: 1500,
          center: true,
        });
        return;
      }
      if (!contact) {
        this.$message({
          message: "请填写联系人",
          type: "warning",
          duration: 1500,
          center: true,
        });
        return;
      }
      let params = this.form;
      if(this.destinations && this.destinations.length>0){
        let destination = ""
        this.destinations.forEach(item=>{
          if(destination){
            destination += "," + item.name
          }else{
            destination = item.name
          }
        })
        this.form.destinationName = destination
      }
      if(this.plays && this.plays.length>0){
        let play = ""
        this.plays.forEach(item=>{
          if(play){
            play += "," + item.playName
          }else{
            play = item.playName
          }
        })
        this.form.playName = play;
      }
      this.form.type = "1";
      axios
        .post(`/api/requirement/submit`, JSON.stringify(params), {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        })
        .then((res) => {
          console.log(res);
          let msg = "";
          if (res.data) {
            if (res.data.code == 200) {
               if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "基本信息提交成功";
                }
                this.$message({
                  message: msg,
                  type: "success",
                  center: true,
                });
                this.clearForm();
            } else {
              if (res.data.code == 500) {
                
                if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "基本信息提交失败";
                }
                this.$message({
                  message: msg,
                  type: "error",
                  duration: 1500,
                  center: true,
                });
              }
            }
          }
        });
    },
  },
  mounted() {
    this.getBanner();
    this.closeSelectContent();
    this.getSurroundCityList();
    this.getDomesticCityList();
    this.getForeignCityList();
    this.getTbCondition();
    this.loading = true;
    // 微信分享
    if (wxShare.is_wx()) {
      wxShare.wxReWriteShare(
        `${this.$store.state.defaultTitle}`,
        `${this.$store.state.defaultDesc}`,
        `${window.location.href}`,
        `${this.$store.state.defaultPic}`
      );
    }
  },
};
</script>

<style scoped>
.container {
  width: 100%;
}
.container-top {
  background: #f8f8f8;
  background-repeat: no-repeat;
  /* background-position-x: center; */
  background-size: cover;
  background-image: var(--background);
  /* background-image: url(var(--background)); */
  /* background-size: 1920px 350px; */
  height: 175px;
}
.container-bottom {
  text-align: left;
  margin-bottom: 20px;
  margin-top: 20px;
  /* width: 1060px; */
  width: 960px;
  position: relative;
  margin: 0 auto;
  padding: 40px 0;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}
.container-bottom .custom-item {
  display: flex;
  flex-direction: row;
  margin: 10px 10px;
}
.container-bottom .custom-item .title {
  /* flex: 1; */
}
.container-bottom .custom-item .title2 {
  line-height: 35px;
}
.container-bottom .custom-item .content {
  display: flex;
  flex-direction: row;
  flex: 8;
  flex-wrap: wrap;
}
.selectDestinations{
  position: relative;
  left: 76px;
}
.selectDestinations .selectDestinationItem{
    padding: 10px 3px 10px 10px;
    border: 2px solid #359ff8;
    margin-left: 5px;
}
.selectDestinationItem .destinationName{
  color:#359ff8;
  font-size: 14px;
}
.selectDestinationItem .close{
  color:#359ff8;
  cursor: pointer;
  margin-left: 10px;
}
.selectPlays{
  position: relative;
  left: 76px;
}
.selectPlays .selectPlayItem{
    padding: 10px 3px 10px 10px;
    border: 2px solid #359ff8;
    margin-left: 5px;
}
.selectPlays .playName{
  color:#359ff8;
  font-size: 14px;
}
.selectPlayItem .close{
  color:#359ff8;
  cursor: pointer;
  margin-left: 10px;
}
.destinationSearch,.playSearch{
  position: absolute;
    background: #fff;
    width: 340px;
    height: 300px;
    border-radius: 4px;
    box-shadow: 0 2px 10px 0 rgb(0 0 0 / 10%);
    border-radius: 10px;
    top: 45px;
    z-index: 10;
    overflow: auto;
}

.destinationSearch .searchList .searchItem,
.playSearch .searchList .searchItem{
  font-size:14px;
  line-height: 30px;
  padding: 5px;
}
.destinationSearch .searchList .select,
.playSearch .searchList .select{
  color: #999;

}
.destinationSearch .searchList .unselect,
.playSearch .searchList .unselect{
  color: #359ff8;
  cursor: pointer;
}
.destinationSearch .searchList .unselect:hover,
.playSearch .searchList .unselect:hover{
  background: #359ff822;
}
.destinationSearch .searchList .searchItem .selectTip,
.playSearch .searchList .searchItem .selectTip{
  color: #999;
}
/* .container-bottom .custom-item .content>>>.el-radio__label{
  font-size: 16px;
    color: #222;
    padding: 0 10px;
    font-weight: 700;
    width: 180px;
} */
/* .container-bottom .custom-item .content >>> .el-radio__inner {
  width: 20px;
  height: 20px;
}
.container-bottom .custom-item .content >>> .el-radio__inner::after {
  width: 6px;
  height: 6px;
}
.container-bottom .custom-item .content >>> .el-radio__inner::after {
  width: 6px;
  height: 6px;
}
.container-bottom .custom-item .content >>> .el-radio__label {
  font-size: 16px;
  color: #222;
  padding: 0 10px;
  font-weight: 700;
  width: 170px;
  padding: 0px 0px 20px 10px;
  display: inline-block;
} */

/* .container-bottom .custom-item .content >>> .el-radio__input {
    cursor: pointer;
    vertical-align: middle;
    position: absolute;
    display: none;
    bottom: 0px;
    right: 0px;
}
.container-bottom .custom-item .content >>> .el-radio__inner::after {
  display: inline !important;
} */

.container-bottom .custom-item .content >>> .el-radio{
  margin-right: 5px;
}
.custom-item .title  span {
  width: 80px;
  font-size: 16px;
  font-weight: 700;
  color: #222;
  line-height: 20px;
  height: 20px;
  display: inline-block;
  text-align: left;
}
.custom-item .title .mark {
  width: 21px;
  font-size: 16px;
  font-weight: 700;
  color: #222;
  line-height: 20px;
  height: 20px;
  display: inline-block;
  text-align: left;
}
.custom-item .title .require {
  width: 59px;
  font-size: 16px;
  font-weight: 700;
  color: #222;
  line-height: 20px;
  height: 20px;
  display: inline-block;
  text-align: left;
}
.custom-item .require::after {
  content: "*";
  color: #f00;
  font-size: 14px;
  padding-right: 5px;
}
/* .custom-item .require .content::after ::after {
  content: ":";
  color: #000;
  font-size: 14px;
  padding-right: 5px;
} */
/* el-select 样式 */
.custom-item >>> .el-input__inner {
  /* border: none; 
    border-color: transparent ;
    
    color:#000;
    font-weight: 700; */
  background: #f8f8f8;
  border: none;
  width: 340px;
}
.custom-item >>> .el-textarea__inner {
  background: #f8f8f8;
  width: 100%;
  border: none;
  min-height: 100px !important;
}
.sendCode {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  border: none;
  width: 340px;
  background: #f8f8f8;
  border-radius: 6px;
}
.custom-item .sendCode >>> .el-input__inner {
  background: #f8f8f8;
  border: none;
  width: 260px;
}
.sendCode span {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: rgba(23, 211, 161, 0.2);
  cursor: pointer;
  width: 80px;
}
.sendCode .active-txt2 {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: rgba(23, 211, 161);
  cursor: pointer;
  width: 80px;
}

.custom-last-item {
  display: flex;
  flex-direction: row;
  /* justify-content: center; */
  position: relative;
  margin: 40px 0px;
}
.custom-last-item div {
  width: 340px;
  position: absolute;
  left: 110px;
  line-height: 50px;
  outline: none;
  background: none;
  border: none;
  height: 50px;
  cursor: pointer;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  background-color: #222;
  border-radius: 6px;
  text-align: center;
}
.content>>>.el-radio-button__inner, .el-radio-group{
  display: flex;
  flex-wrap: wrap;
  flex: 0 0 120%;
}
.component-select{
  position: relative;
}

.component-select .component-select-content {
  position: absolute;
  width: 99%;
  opacity: 0;
  margin: 45px 0 0;
  padding: 20px 10px;
  z-index: 1001 !important;
  overflow: auto;
  background: #fff;
  transform: scaleY(0);
  transform-origin: center top 0;
  box-shadow: 0 2px 10px 0 rgb(0 0 0 / 10%);
  border-radius: 10px;
  transition: all 0.3s ease-in-out;
  opacity: 1;
  z-index: 900;
  transform: scaleY(1);
}
.component-select
  .component-select-content
  .component-select-content-items-fold {
  height: 100px;
}

.component-select .component-select-content .component-select-content-items {
  margin: 10px;
  overflow: hidden;
}

.component-select .component-select-content .component-select-content-items ul {
  list-style: none;
  text-align: left;
}
.component-select
  .component-select-content
  .component-select-content-items
  ul
  li {
  cursor: pointer;
  padding: 0 12px;
  margin: 0 4px 4px 0;
  height: 30px;
  display: inline-block;
  line-height: 30px;
  font-size: 14px;
  color: #4a4a4a;
  border-radius: 15px;
}
.component-select
  .component-select-content
  .component-select-content-items
  ul
  li:active,
.component-select
  .component-select-content
  .component-select-content-items
  ul
  li:hover {
  color: #359ff8 !important;
  font-weight: 700;
}

.component-select
  .component-select-content
  .component-select-content-items
  ul
  .active {
  color: #359ff8 !important;
  font-weight: 700;
}

.component-tabtitle .component-tabtitle-item .component-tabtitle-border {
  background: #359ff8;
  border-radius: 4px 4px 0 0;
  width: 60px;
  height: 4px;
  position: absolute;
  left: 50%;
  margin-left: -30px;
  bottom: -10px;
}


.component-tabtitle {
  flex-direction: row;
  flex-wrap: wrap;
  display: flex;
}

.component-tabtitle .component-tabtitle-item {
  padding: 0 20px;
  cursor: pointer;
  position: relative;
}

/* element.style {
    font-size: 16px;
    color: rgb(34, 34, 34);
} */
.component-tabtitle .component-tabtitle-item .component-tabtitle-name {
  display: inline-block;
  font-size: 16px;
  color: #222;
  vertical-align: middle;
}
.destinations, .plays{
  position: relative;
}
.destinations .tip, .plays .tip{
  position: absolute;
  display: inline-block;
    padding-left: 15px;
    height: 14px;
    line-height: 14px;
    font-size: 12px;
    color: #999;
    left: 350px;
    top: 15px;
}

.destinations .tip .el-icon-warning, .plays .tip .el-icon-warning{
  color: #359ff8;
}
</style>
<style>
/* @media screen and (max-width: 767px) {
  .el-dialog {
    width: 80% !important;
  }
} @media only screen and (max-width: 767px) */
</style>




// WEBPACK FOOTER //
// src/components/custom.vue